import React, { useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';
import { Button } from 'styles/admin';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { MSTeamsLogoSrc } from 'constants/icons';
import { KH_LINKS } from 'constants/knowledgeHubLinks';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import TooltipInfo from 'uiToolkit/TooltipInfo';
import { Typography16, Typography17 } from 'uiToolkit/Typography';

import { StyledContainer, Logo } from '../styles';
import GuideSection from './guideSection';
import InstallationSection from './installationSection';

const MSTeamsAppUrl = 'https://teams.microsoft.com/l/app/72882807-95fe-48d0-95f2-1dee861c4c09?source=store-copy-link';

/**
 * @deprecated 8-04-2025
 */
const MSTeamsPlugin = () => {
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Company-settings-MS Teams',
      },
    });
  }, []);
  return (
    <StyledContainer>
      <HeaderMarginContainer>
        <Grid container spacing={4}>
          <Grid item>
            <Logo src={MSTeamsLogoSrc} width={80} />
          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Grid item xs={6}>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <VerticallyAlignedFlexContainer>
                  <Typography16 bottomGutter={2}>Microsoft Teams App</Typography16>
                  <TooltipInfo
                    title={KH_LINKS.MS_TEAM.description}
                    linkUrl={KH_LINKS.MS_TEAM.url}
                    leftGutter={1}
                    bottomGutter={1.5}
                  />
                </VerticallyAlignedFlexContainer>
                <Typography17 bottomGutter={3}>Manage goals and tasks without ever leaving Teams</Typography17>
              </Grid>
              <Grid item>
                <Button blue size="large" topGutter={4} href={MSTeamsAppUrl} target="_blank">
                  Install
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </HeaderMarginContainer>

      <InstallationSection />
      <GuideSection />
    </StyledContainer>
  );
};

export default MSTeamsPlugin;
